export const type = {
  anualList: '[Medicamentos Iniciado Autorizado Anual] anualList',
  mensualList: '[Medicamentos Iniciado Autorizado Mensual] mensualList',
};
